import { useEffect, useState } from "react";

import {
  Card,
  Typography,
  CardContent,
  Grid,
  TextField,
  Button,
  Stack,
  Divider,
  CardActionArea,
  Alert,
} from "@mui/material";
import { PersonOutline, Search } from "@mui/icons-material";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { orderActions } from "../../../store/order/order-slice";

import Colors from "../../../constants/Colors";
// import { Client } from '../../../models/client.model';

interface Props {
  toggleModal: () => void;
}

const OrderClientDetailCard = (props: Props) => {
  const selectedClient = useAppSelector((state) => state.order.selectedClient);
  const quickClientName = useAppSelector(
    (state) => state.order.order.clienteNome || "",
  );
  const canTypeClient = useAppSelector(
    (state) => state.tenantConfiguration.digitarCliente === true,
  );
  const [quickClientInput, setQuickClientInput] = useState(quickClientName);
  const dispatch = useAppDispatch();
  // const isReadOnly = !useAppSelector(
  //   (state) => state.order.orderSituation.permiteEdicao
  // );

  const isReadOnly = useAppSelector(
    (state) => state.readability.isOrderReadOnly,
  );

  useEffect(() => {
    setQuickClientInput(quickClientName);
  }, [quickClientName]);

  const handleQuickClientChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = ev.target.value;
    setQuickClientInput(nextValue);
    dispatch(orderActions.setQuickClient(nextValue));
  };

  const handleQuickClientKeyDown = (
    ev: React.KeyboardEvent<HTMLDivElement>,
  ) => {
    if (ev.key === " ") {
      ev.stopPropagation();
    }
  };

  return (
    <Grid item xs={12} md={12}>
      <Card>
        {!isReadOnly && !canTypeClient ? (
          <CardActionArea onClick={props.toggleModal}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <PersonOutline fontSize={"inherit"} /> Cliente
                  </Typography>
                </Grid>
                {selectedClient && (
                  <Grid item xs={12} md={12}>
                    <Typography variant="h6">{selectedClient.apelido}</Typography>
                    <Typography variant="body2" color={"gray"}>
                      {selectedClient.nome}
                    </Typography>
                    {!!selectedClient.id && (
                      <Typography
                        variant="body2"
                        color={"gray"}
                      >
                        {selectedClient.id}
                      </Typography>
                    )}
                  </Grid>
                )}
                {!!quickClientName && !selectedClient?.id && (
                  <Grid item xs={12} md={12}>
                    <Alert severity="warning">
                      Selecione um cliente cadastrado para continuar.
                    </Alert>
                  </Grid>
                )}
                <Grid item xs={12} md={12}>
                  <Button
                    component="span"
                    fullWidth
                    variant="outlined"
                    color="success"
                    startIcon={<Search />}
                  >
                    Selecionar cliente cadastrado
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        ) : (
          <CardContent>
            <Grid container spacing={1.25}>
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{
                    backgroundColor: Colors.titleRowWithBackgroundColor,
                    pl: 1,
                    pt: 0.75,
                    mt: -1,
                  }}
                  variant="body2"
                  color={Colors.titleWithBackgroudColor}
                >
                  <PersonOutline fontSize={"inherit"} /> Cliente
                </Typography>
              </Grid>
              {!isReadOnly && canTypeClient && (
                <>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={0.75}>
                      <Stack spacing={0.25}>
                        <Typography
                          variant="body2"
                          fontWeight={"bold"}
                          color={Colors.primary}
                        >
                          Cliente Avulso
                        </Typography>
                        <Typography variant="caption" color={"gray"}>
                          Informe um nome sem cadastro
                        </Typography>
                      </Stack>
                      <TextField
                        fullWidth
                        label="Nome do cliente"
                        size="small"
                        color="success"
                        value={quickClientInput}
                        onChange={handleQuickClientChange}
                        onKeyDown={handleQuickClientKeyDown}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Divider>
                      <Typography variant="caption" color={"gray"}>
                        ou
                      </Typography>
                    </Divider>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={0.75}>
                      <Typography
                        variant="body2"
                        fontWeight={"bold"}
                        color={Colors.primary}
                      >
                        Cliente Cadastrado
                      </Typography>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="success"
                        startIcon={<Search />}
                        onClick={props.toggleModal}
                      >
                        Selecionar cliente cadastrado
                      </Button>
                    </Stack>
                  </Grid>
                </>
              )}
              {selectedClient && (
                <Grid item xs={12} md={12}>
                  {!isReadOnly && <Divider sx={{ mb: 1 }} />}
                  <Typography variant="body2" color={"gray"} fontWeight={"bold"}>
                    Cliente informado
                  </Typography>
                  <Typography variant="h6">{selectedClient.apelido}</Typography>
                  <Typography variant="body2" color={"gray"}>
                    {selectedClient.nome}
                  </Typography>
                  {!!selectedClient.id && (
                    <Typography variant="body2" color={"gray"}>
                      {selectedClient.id}
                    </Typography>
                  )}
                </Grid>
              )}
            </Grid>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
};

export default OrderClientDetailCard;
